<template>
	<article class="small-12 listing unitListing bgWhite borderRadius4 border light flex vertical-align animated fadeIn" v-bind:class="{ active: isActive }" v-if="unit">
		<router-link :to="{ name: 'Unit', params: { id: $route.params.id, unitID: unit.id } }" class="flex small-12 vertical-align">
			<div class="small-2 columns">
				<p class="small-12 text-overflow">{{unit.attributes.number}}</p>
			</div>
			<div class="small-2">
				<p class="small-12 text-overflow cGreen" v-if="unit.attributes.available == true">
					<span class="badge bgGreen borderRadius50">Available</span>
				</p>
				<p class="small-12 text-overflow" v-else>
					<span class="badge bgRed borderRadius50">Rented</span>
				</p>
			</div>
			<div class="small-2 columns">
				<p class="small-12 text-overflow">
					${{unit.attributes.rent.current | noDecimals}}
				</p>
			</div>
			<div class="small-4 columns">
				<p class="small-12 text-overflow flex vertical-align" v-if="resident">
					<picture class="avatar round flex justify-center vertical-align bgPrimaryBlue cWhite">
						<span>{{resident.attributes.contact_information.first_name | abbreviateName}} {{resident.attributes.contact_information.last_name | abbreviateName}}</span>
					</picture> 
					{{resident.attributes.contact_information.first_name}} {{resident.attributes.contact_information.last_name}}
				</p>
				<p class="small-12 text-overflow" v-else>
					--
				</p>
			</div>
			<div class="small-2 actions flex justify-right">
				<a class="border borderRadius4 flex vertical-align justify-center viewButton cMedium">
					<i class="material-icons">navigate_next</i>
				</a>
			</div>
		</router-link>
	</article>
</template>

<script>

	// Import firebase
	import { firebaseAuth, propertiesModel, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'
	import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PrimaryNav from '@/components/framework/nav/PrimaryNav.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Unit',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			AbbreviateNumbersFilters,
			AbbreviateNameFilter

		],

		/*
		**  Set the props
		*/

		props: {

			unit: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			resident: null,
			openMenuDropdown: false,
			isActive: false,
			future_item: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			unit: {

				immediate: true, // Load on created
				handler(unit) {

					// Get the resident
					if (unit && unit.relationships.resident) this.getResident();

				}

			}

		},

		/*
		**  Do this first
		*/

		created() {

			window.addEventListener("click", this.closeEditMenuDropdown);

		},

		/*
		**  Do this last
		*/

		beforeDestroy() {

			window.removeEventListener("click", this.closeEditMenuDropdown);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			getResident: function() {

				// Get the resident doc
				propertiesModel.doc(this.$route.params.id).collection('residents').doc(this.unit.relationships.resident).get()
				.then(doc => {

					if (!doc.exists) return;
					
					// Add to the prop
					this.resident = doc.data();

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Unit Listing - Get Resident Document',
						errorType: 'Firestore Database',
						section: 'Property Units',
						component: 'Unit',
						error: error
					});

				});

			},

			throwDeleteModal: function() {

				//

			},

			openEditMenuDropdown: function() {

				// Set the prop
				if (!this.openMenuDropdown) {

					// Open menu
					this.openMenuDropdown = true;

					// Set the z-index of the unit
					this.isActive = true;

				} else {

					// Open menu
					this.openMenuDropdown = false;

					// Set the z-index of the unit
					this.isActive = false;

				}

			},

			openEditMenu: function() {

				//

			},

			closeEditMenuDropdown: function(e) {

		    	if (!this.$el.contains(e.target)) {

		    		// Close menu
		    		this.openMenuDropdown = false;

		    		// Set the z-index of the unit
					this.isActive = false;

		    	}

		    },

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>